import { ConfigService, PITEventService, UtilsJsonConverterDate, UtilsMisc, UtilsString } from '@pit/core';
import { PinSignalRClientService, SignaRRetryPolicy } from '@pit/core-signalr';
import { IDtoDevice } from '@pit/frontend-model';
import { PinItTrackFrontendDataServicesAccessor } from '../module.data/accessor/implementations/pin.it.track.frontend.data.services.accessor';
import { PinItTrackFrontendEntityStoreFacadesAccessor } from '../module.store/accessor/pin.it.track.frontend.entity.store.facades.accessor';

export class PinItTrackFrontendEventSignalRHandler {

    constructor(private configService: ConfigService, private dataServicesAccessor: PinItTrackFrontendDataServicesAccessor, private entityStoreFacadesAccessor: PinItTrackFrontendEntityStoreFacadesAccessor,
        private signalRService: PinSignalRClientService, private eventService: PITEventService) {
    }

    public async initializeAsync(): Promise<void> {
        this.signalRService.setRetryPolicy(new SignaRRetryPolicy());
        this.signalRService.subscribeForConnectionChange(this.signalRConnectionChangedAsync.bind(this));
        this.signalRService.addListener('notice.receive', this.handleMessageNoticeReceiveAsync.bind(this));
        this.signalRService.addListener('device.connection.on', this.handleDeviceConnectedAsync.bind(this));
        this.signalRService.addListener('device.connection.off', this.handleDeviceDisconnectedAsync.bind(this));
    }

    public async startAsync(): Promise<void> {
        if (this.configService.configCommChannel.useChannel === true) {
            await this.signalRService.startConnectionAsync();
        }
    }

    public async stopAsync(): Promise<void> {
        await this.signalRService.closeConnectionAsync();
    }

    private async signalRConnectionChangedAsync(value: boolean, connectionId: string): Promise<void> {
        if (this.configService.configCommChannel.useChannel === true) {
            if (value === true) {
                try {
                    await this.signalRService.sendMessageAsync('registerWeb');
                } catch (error) {
                }
            } else {
                const devices: IDtoDevice[] = await this.entityStoreFacadesAccessor.deviceStoreFacade.getAllItemsAsync();
                if ((UtilsMisc.isNullOrUndefined(devices) === false) && (devices.length > 0)) {
                    for (const device of devices) {
                        try {
                            device.connectionId = null;
                        } catch (error) {
                            // Ignore read-only property error
                        }
                        //await this.entityStoreFacadesAccessor.deviceStoreFacade.saveItemAsync(device);
                    }
                }
            }
        }
    }

    private async handleDeviceConnectedAsync(data: any): Promise<void> {
        try {
            let device: IDtoDevice = await this.entityStoreFacadesAccessor.deviceStoreFacade.getDeviceByDeviceIdAsync(data.deviceId);
            if (UtilsMisc.isNullOrUndefined(device) === false) {
                try {
                    device.connectionId = data.connectionId;
                } catch (error) {
                    // Ignore read-only property error
                }
                device.isOnline = true;
                if (UtilsMisc.isNullOrUndefined(data.batteryLevel) === false) {
                    device.batteryLevel = data.batteryLevel;
                    device.batteryStatusTimestamp = data.batteryStatusTimestamp;
                    device.batteryIsCharging = data.batteryIsCharging;
                }
                if (UtilsMisc.isNullOrUndefined(data.modifiedAt) === false) {
                    device.modifiedAt = (new UtilsJsonConverterDate()).deserialize(data.modifiedAt);
                }
                if (UtilsMisc.isNullOrUndefined(data.lastSync) === false) {
                    device.lastSync = (new UtilsJsonConverterDate()).deserialize(data.lastSync);
                }

                this.entityStoreFacadesAccessor.deviceStoreFacade.upsertItemToStore(device);
            }
        } catch (error) {
        }
    }

    private async handleDeviceDisconnectedAsync(data: any): Promise<void> {
        try {
            let device: IDtoDevice = await this.entityStoreFacadesAccessor.deviceStoreFacade.getDeviceByDeviceIdAsync(data.deviceId);
            if (UtilsMisc.isNullOrUndefined(device) === false) {
                try {
                    device.connectionId = null;
                } catch (error) {
                    // Ignore read-only property error
                }
                device.isOnline = false;
                if (UtilsMisc.isNullOrUndefined(data.batteryLevel) === false) {
                    device.batteryLevel = data.batteryLevel;
                    device.batteryStatusTimestamp = data.batteryStatusTimestamp;
                    device.batteryIsCharging = data.batteryIsCharging;
                }
                if (UtilsMisc.isNullOrUndefined(data.modifiedAt) === false) {
                    device.modifiedAt = (new UtilsJsonConverterDate()).deserialize(data.modifiedAt);
                }
                if (UtilsMisc.isNullOrUndefined(data.lastSync) === false) {
                    device.lastSync = (new UtilsJsonConverterDate()).deserialize(data.lastSync);
                }

                this.entityStoreFacadesAccessor.deviceStoreFacade.upsertItemToStore(device);
            }
        } catch (error) {
        }
    }

    private async handleMessageNoticeReceiveAsync(message: string): Promise<void> {
        alert(message);
        /*const alertOptions: AlertOptions = {
            backdropDismiss: false,
            header: 'NACHRICHT',
            message: message,
            buttons: [
                {
                    text: 'Schließen',
                }
            ]
        };
        this.eventService.sendEvent(EventAlert.Alert, alertOptions);*/
    }

}
